module.exports = __webpack_public_path__ + "img/diancifa.1b3a427b.png";